module.exports = __webpack_public_path__ + "img/12-small.1ae6df08.png";